import type { Review, ReviewVoteLink } from '@alltrails/types/Review';

/** Link rel values returned by the API for review voting (VotePresenter). */
export const ReviewVoteLinkRel = {
  Upvote: 'urn:alltrails:reviews:upvote',
  Downvote: 'urn:alltrails:reviews:downvote',
  RemoveVote: 'urn:alltrails:reviews:remove-vote'
} as const;

export type ReviewVoteLinkRelType = (typeof ReviewVoteLinkRel)[keyof typeof ReviewVoteLinkRel];

export function getUpvoteLink(review: Review): ReviewVoteLink | undefined {
  return review.votes?.links?.find(link => link.rel === ReviewVoteLinkRel.Upvote);
}

export function getDownvoteLink(review: Review): ReviewVoteLink | undefined {
  return review.votes?.links?.find(link => link.rel === ReviewVoteLinkRel.Downvote);
}

export function getRemoveVoteLink(review: Review): ReviewVoteLink | undefined {
  return review.votes?.links?.find(link => link.rel === ReviewVoteLinkRel.RemoveVote);
}
